import { assertNever } from '@kofno/piper';
import { array } from 'jsonous';
import { Maybe } from 'maybeasy';
import { getFieldValue } from '../../../../../FormFields';
import ReactionComponent, { RCProps } from '../../../../../ReactionComponent';
import { FormFieldOutputValue, FieldValue } from '../../../Types';
import { State } from '../Store/Types';
import RadioFieldStore from '../Store';
import { formFieldValueDecoder } from '../../../Decoders';
import { asMaybe } from '@execonline-inc/error-handling';
import { multiSelectPrefillSeed } from '../../Helpers';

interface Props extends RCProps<RadioFieldStore> {}

const validateValue = (value: FormFieldOutputValue): Maybe<FieldValue[]> =>
  asMaybe(array(formFieldValueDecoder).decodeAny(value));

class RadioFieldReactions extends ReactionComponent<RadioFieldStore, State, Props> {
  tester = () => this.props.store.state;

  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'initializing':
        state.segmentStore.addEmbeddedFormFieldOutput(store);
        // DVLP-7754 / DVLP-7781 precedence: participant's own saved answer
        // wins; otherwise seed from the server-supplied prefill in
        // +state.formField.value+ (backend hydrates from
        // +AttributableAttribute+).
        const saved = getFieldValue(state.segmentStore.results, store.id)
          .andThen(validateValue)
          .getOrElseValue([]);
        const seeded = saved.length === 0 ? multiSelectPrefillSeed(state.formField) : saved;
        store.ready(state.formField, seeded);
        break;
      case 'waiting':
      case 'ready':
      case 'auto-saving':
        break;
      default:
        assertNever(state);
    }
  };
}

export default RadioFieldReactions;
